export const initialPath = '';